import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DSDateInput from '@elliemae/ds-basic/form/DateInputV2';
import DSInputGroup from '@elliemae/ds-basic/form/InputGroup';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var DATE_FORMAT = 'MMDDYYYY';
var blockname = 'date-picker-header';
var Header = aggregatedClasses('div')(blockname);

var isFn = function isFn(variable) {
  return typeof variable === 'function';
};

var DatePickerHeader = function DatePickerHeader(_ref) {
  var _ref$onInputChange = _ref.onInputChange,
      onInputChange = _ref$onInputChange === void 0 ? function () {
    return null;
  } : _ref$onInputChange,
      selectedDate = _ref.selectedDate,
      updateKeyDate = _ref.updateKeyDate;

  var _useState = useState(isFn(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format) ? selectedDate.format(DATE_FORMAT) : ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    if (isFn(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format)) {
      setValue(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format(DATE_FORMAT));
    }
  }, [selectedDate]);

  var handleOnChange = function handleOnChange(newDate) {
    setValue(newDate);
  };

  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.key === 'Enter' && value.length === DATE_FORMAT.length) {
      var momentValue = moment(value, DATE_FORMAT);
      onInputChange(momentValue);
      updateKeyDate(momentValue);
    }
  };

  return /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(DSInputGroup, null, /*#__PURE__*/React.createElement(DSDateInput, {
    onChange: handleOnChange,
    onKeyDown: handleOnKeyDown,
    value: value,
    containerProps: {
      'data-testid': 'start-date'
    }
  })));
};

DatePickerHeader.propTypes = {
  onInputChange: PropTypes.func,
  selectedDate: PropTypes.any,
  updateKeyDate: PropTypes.any
};

export default DatePickerHeader;
//# sourceMappingURL=DatePickerHeader.js.map
